module.exports = __webpack_public_path__ + "img/sync_error.46c4fd98.svg";